<template>
<div class="chapter">
<div class="inner_page">
<p class="Basic-Paragraph para-style-override-2"><span class="char-style-override-10">“I have called you back from the ends of the earth so you can serve me. For I have chosen you and will not throw you away. Don’t be afraid, for I am with you. Do not be dismayed, for I am your God. I will strengthen you. I will help you. I will uphold you with my victorious right hand.”</span></p>
<p class="Basic-Paragraph para-style-override-2">Isaiah 41: 9-10</p>
<p class="Basic-Paragraph para-style-override-9"></p>
<p class="Basic-Paragraph para-style-override-9"></p>
<p class="Basic-Paragraph para-style-override-9">And so it was with the Coast Guard in <br/>New Orleans, in September of 2005.</p>
<p class="Basic-Paragraph para-style-override-2"><span class="char-style-override-4"></span></p>
<p class="x-1-chapter-number"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Verse.vue?913838c8